<h3 mat-dialog-title>Changement de statut</h3>
<mat-dialog-content class="thin">
    Etes-vous sûr de vouloir changer le statut vers "{{ data.newTypeName }}" ?
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="space-around center">
  <button mat-flat-button class="button-flat black" (click)="closeDialog()" >Non</button>
  <button mat-flat-button class="button-flat red" mat-dialog-close>Oui</button>
</mat-dialog-actions>
